// Atribución de origen (src / utm_*) guardada 30 días en el navegador; se adjunta a los pedidos eSIM
const KEY = "lw_attribution";
const TTL = 30 * 86400000;
const FIELDS = ["src", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export const captureAttribution = (search = window.location.search, path = window.location.pathname) => {
  try {
    const qs = new URLSearchParams(search);
    const found = {};
    FIELDS.forEach(f => { const v = qs.get(f); if (v) found[f] = v.slice(0, 64); });
    if (!Object.keys(found).length) return getAttribution();
    const attr = { ...found, landing: path.slice(0, 120), at: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(attr));
    return attr;
  } catch { return null; }
};

export const getAttribution = () => {
  try {
    const a = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!a || Date.now() - (a.at || 0) > TTL) return null;
    return a;
  } catch { return null; }
};

export const attributionForOrder = () => {
  const a = getAttribution();
  if (!a) return {};
  const { at, ...rest } = a;
  return { ...rest, captured_at: new Date(at).toISOString() };
};
